export default __webpack_public_path__ + "static/media/Bounty Hunter's Dirk.06a4f596.jpg";